export const SUBJECTS = [
  "Mathématiques",
  "Français",
  "Histoire-Géo",
  "SVT",
  "Physique-Chimie",
  "Anglais",
  "Espagnol",
  "Philosophie",
  "SES",
  "NSI",
  "Sport",
  "Autre",
];

export const SUBJECT_STYLES = {
  "Mathématiques": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Physique-Chimie": "bg-sky-50 text-sky-700 border-sky-200",
  "Français": "bg-rose-50 text-rose-700 border-rose-200",
  "SVT": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Histoire-Géo": "bg-amber-50 text-amber-700 border-amber-200",
  "Anglais": "bg-purple-50 text-purple-700 border-purple-200",
  "Philosophie": "bg-teal-50 text-teal-700 border-teal-200",
  "Espagnol": "bg-orange-50 text-orange-700 border-orange-200",
  "SES": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "NSI": "bg-violet-50 text-violet-700 border-violet-200",
  "Sport": "bg-lime-50 text-lime-700 border-lime-200",
};

export function subjectStyle(subject) {
  return SUBJECT_STYLES[subject] || "bg-slate-100 text-slate-700 border-slate-200";
}

export const SUBJECT_DOT = {
  "Mathématiques": "#4F46E5",
  "Physique-Chimie": "#0EA5E9",
  "Français": "#F43F5E",
  "SVT": "#10B981",
  "Histoire-Géo": "#F59E0B",
  "Anglais": "#8B5CF6",
  "Philosophie": "#14B8A6",
  "Espagnol": "#F97316",
  "SES": "#06B6D4",
  "NSI": "#7C3AED",
  "Sport": "#84CC16",
};

export const LEVELS = ["6ème", "5ème", "4ème", "3ème", "Seconde", "Première", "Terminale"];

export const DAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

export const HOMEWORK_STATUS = {
  a_faire: { label: "À faire", classes: "bg-slate-100 text-slate-700" },
  en_cours: { label: "En cours", classes: "bg-amber-100 text-amber-800" },
  termine: { label: "Terminé", classes: "bg-emerald-100 text-emerald-800" },
};

export const PLANS = {
  gratuit: {
    name: "Gratuit",
    price: "0 €",
    period: "pour toujours",
    tagline: "L'essentiel pour démarrer",
    features: [
      "Emploi du temps",
      "Gestion des devoirs",
      "Objectifs du mois",
      "5 fiches de révision (+2 par niveau gagné)",
      "Exercices niveau Gratuit (+2 Basique par niveau)",
    ],
    missing: ["Génération de fiches par IA", "Planning de révision IA", "Statistiques détaillées"],
  },
  basique: {
    name: "Basique",
    price: "4,99 €",
    period: "/ mois",
    priceYear: "34,99 €",
    savings: "Soit 2,92 €/mois au lieu de 4,99 €",
    discount: "-42 %",
    tagline: "Pour s'organiser vraiment",
    features: [
      "Tout le plan Gratuit",
      "Fiches de révision illimitées",
      "Tous les exercices Basique",
      "Rappels de devoirs importants",
      "Suivi de progression",
    ],
    missing: ["Génération de fiches par IA", "Planning de révision IA", "Statistiques détaillées"],
  },
  premium: {
    name: "Premium",
    price: "7,99 €",
    period: "/ mois",
    priceYear: "59,99 €",
    savings: "Soit 5,00 €/mois au lieu de 7,99 €",
    discount: "-37 %",
    tagline: "Le coach IA personnel",
    features: [
      "Tout le plan Basique",
      "Fiches générées par IA",
      "Planning de révision personnalisé IA",
      "Tous les exercices + Premium",
      "Statistiques détaillées & séries",
    ],
    missing: [],
  },
};
